import { render } from "./Loading.vue?vue&type=template&id=494b15c6&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=494b15c6&lang=scss&scoped=true"

import exportComponent from "/builds/juan_arzate/campestre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494b15c6"]])

export default __exports__